import { gql } from '@apollo/client';

import { ASSET2_FRAGMENT } from '../../../hooks/fragments/asset2Fragment';

export const GET_CREATIVE_DATA_ASSET2 = gql`
  query getCreativeDataAsset2($assetIdList: [String!]!) {
    getAsset2ByIDs(assetIdList: $assetIdList) {
      ...asset2Fragment
    }
  }
  ${ASSET2_FRAGMENT}
`;
